export const compareIsNamesEqual = (
  infoName: string | undefined,
  passportName: string | undefined
) => {
  if (!infoName || !passportName) {
    return false;
  }
  return infoName.trim().toLowerCase() === passportName.trim().toLowerCase();
};
